<template>
  <div>
    <Banner/>
    <ServiceContainer/>
    <CoreAdvantages/>
    <CaseModule/>
    <HomeCustomer/>
    <HomeContact/>
  </div>
</template>

<script>
import Banner from '@/components/HomeBanner.vue';
import ServiceContainer from '@/components/ServiceContainer.vue';
import CoreAdvantages from '@/components/CoreAdvantages.vue';
import CaseModule from '@/components/CaseModule.vue';
import HomeCustomer from '@/components/HomeCustomer.vue';
import HomeContact from '@/components/HomeContact.vue';
export default {
  components: { Banner, ServiceContainer, CoreAdvantages, CaseModule, HomeCustomer, HomeContact },
  name: 'HomePage',  // 组件名称
};
</script>

<style scoped>

</style>
